document.addEventListener("DOMContentLoaded", function () {
  /* ---------------------*/
  /* ----アコーディオン----*/
  /* --------------------*/
  const accordionItems = document.querySelectorAll(".accordion .acdn");
  accordionItems.forEach(function (item) {
    item.addEventListener("click", function () {
      var content = this.nextElementSibling;

      if (content.classList.contains("is-active")) {
        content.classList.remove("is-active");
        item.classList.remove("is-active");
      } else {
        content.classList.add("is-active");
        item.classList.add("is-active");
      }
    });
  });

  /* ---------------------*/
  /* ----TOPへ遷移する----*/
  /* --------------------*/
  const pageTop = document.getElementById("page-top");

  pageTop.addEventListener("click", function (event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  /* ------------------------------*/
  /* ----pcのヘッダーのホバー処理----*/
  /* ------------------------------*/
  const menuLinks = document.querySelectorAll(".header__menu-link");

  menuLinks.forEach(function (menuLink) {
    const menuList = menuLink.querySelector(".header__menu-nav");

    menuLink.addEventListener("mouseenter", function () {
      menuLink.classList.add("is-active");
      if (menuList) {
        menuList.classList.add("is-active");
      }
    });

    menuLink.addEventListener("mouseleave", function () {
      menuLink.classList.remove("is-active");
      if (menuList) {
        menuList.classList.remove("is-active");
      }
    });
  });

  /* -------------------------*/
  /* ----spのヘッダーの処理----*/
  /* ------------------------*/
  const ham = document.querySelector(".ham");
  const hamNav = document.querySelector(".ham__nav");
  ham.addEventListener("click", function () {
    ham.classList.toggle("is-open");
    hamNav.classList.toggle("is-active");
  });

  /* -------------------------*/
  /* ----ポップアップの処理----*/
  /* ------------------------*/
  function showPopup(popupId) {
    var popup = document.getElementById(popupId);
    if (popup) {
      popup.style.display = "block";
    }
  }

  function closePopup(popup) {
    popup.style.display = "none";
  }

  var popupClick1 = document.getElementById("popup-click1");
  if (popupClick1) {
    popupClick1.addEventListener("click", function () {
      showPopup("popup-display1");
    });
  }

  var popupClick2 = document.getElementById("popup-click2");
  if (popupClick2) {
    popupClick2.addEventListener("click", function () {
      showPopup("popup-display2");
    });
  }

  var popupClick3 = document.getElementById("popup-click3");
  if (popupClick3) {
    popupClick3.addEventListener("click", function () {
      showPopup("popup-display3");
    });
  }

  var popupClick4 = document.getElementById("popup-click4");
  if (popupClick4) {
    popupClick4.addEventListener("click", function () {
      showPopup("popup-display4");
    });
  }

  var popupClick5 = document.getElementById("popup-click5");
  if (popupClick5) {
    popupClick5.addEventListener("click", function () {
      showPopup("popup-display5");
    });
  }

  var closeButtons = document.querySelectorAll(".popup__box-close");
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var popup = button.closest(".popup");
      closePopup(popup);
    });
  });

  /* ----------------------------*/
  /* ----ポップアップスライダー----*/
  /* ----------------------------*/
  function showPopup(popupId) {
    var popup = document.getElementById(popupId);
    if (popup) {
      popup.style.display = "block"; // ポップアップを表示
    }
  }

  function closePopup(popup) {
    popup.style.display = "none"; // ポップアップを非表示
  }

  // DOMContentLoadedでスクリプトを実行
  document.addEventListener("DOMContentLoaded", function () {
    var popupClick6 = document.getElementById("popup-click6");
    if (popupClick6) {
      popupClick6.addEventListener("click", function () {
        showPopup("popup-display6");
      });
    }
    // 他のポップアップも同様に
  });

  // 閉じるボタンのイベント
  var closeButtons = document.querySelectorAll(".popup__box-close");
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var popup = button.closest(".popup");
      closePopup(popup);
    });
  });
});